import React from "react";
import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { PageHeader } from "@/components/Layout";
import { api } from "@/lib/api";
import { Calendar, ArrowUpRight } from "lucide-react";

export default function Blog() {
    const q = useQuery({ queryKey: ["blogs"], queryFn: () => api.get("/blogs").then((r) => r.data) });
    const blogs = q.data || [];

    return (
        <div data-testid="blog-page">
            <PageHeader
                eyebrow="News & Blog"
                title={<>Stories, lessons, and <span className="text-secondary italic font-light">field notes.</span></>}
                sub="Written by our team and volunteers — from program updates to reflections on social impact."
            />

            <section className="mx-auto max-w-7xl px-5 lg:px-10 py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {blogs.map((b) => (
                    <Link
                        key={b.id}
                        to={`/blog/${b.slug}`}
                        data-testid={`blog-${b.slug}`}
                        className="group bg-card border border-border hover:border-primary/40 hover:-translate-y-1 transition-all"
                    >
                        <div className="aspect-[16/10] overflow-hidden bg-muted">
                            <img src={b.featured_image} alt={b.title} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                        </div>
                        <div className="p-6">
                            <div className="flex items-center gap-2 text-xs text-muted-foreground mb-3">
                                <Calendar className="h-3.5 w-3.5" />
                                {new Date(b.created_at).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" })}
                                {b.tags?.length > 0 && <span className="font-eyebrow text-[10px] text-secondary ml-2">{b.tags[0]}</span>}
                            </div>
                            <h3 className="font-display text-xl leading-tight">{b.title}</h3>
                            <p className="mt-2 text-sm text-muted-foreground line-clamp-3 leading-relaxed">{b.excerpt || b.content.replace(/<[^>]+>/g, "").slice(0, 140) + "…"}</p>
                            <div className="mt-4 inline-flex items-center gap-1 text-sm text-primary group-hover:gap-2 transition-all">
                                Read more <ArrowUpRight className="h-4 w-4" />
                            </div>
                        </div>
                    </Link>
                ))}
                {!q.isLoading && blogs.length === 0 && (
                    <div className="text-muted-foreground">No blog posts yet.</div>
                )}
            </section>
        </div>
    );
}
